import { useMutation, useQuery } from '@apollo/client';
import {
  Icon,
  SelectionSheet,
  TableLoading,
  toast,
  AppContext,
  COMMON_CONSTANTS,
  useProduct
} from '@nile/components';
import {
  GET_CURRENT_USER,
  GET_PERSONALIZATION_BY_NAME,
  GET_TICKET_LIST,
  SAVE_PERSONALIZATION
} from '@nile/graphql';
import TicketTable from '@nile/mangifera/src/Components/Ticket/TicketTable';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { AccountClient } from '@nile/graphql';
import { GET_TICKETVIEWS } from '@nile/mangifera/src/Graphql/Mutations/ticketview';
import { Heading, Sheet, Button } from '@superops/ui-design-system';
import { Settings } from '@styled-icons/material';
import React, { useCallback, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';

import styled from 'styled-components';
import { SVGIcon } from '@superops/super-icons';

const StyledCard = styled.div`
  padding: 20px;
  border: 1px solid #efefef;
`;

function WorkspaceSheet(props) {
  const context = useContext(TicketContext);
  const { loading: ticketViewloading, data } = useQuery(GET_TICKETVIEWS);
  const [sheetActive, setSheetActive] = useState(false);
  const toggleSheetActive = useCallback(() => {
    setSheetActive((sheetActive) => !sheetActive);
  }, []);

  const sections = [];
  const allFields = [];
  const actions = {};
  const selectedItems = [];

  const ticketViewSection = {
    name: 'TicketView',
    header: 'Ticket views',
    items: []
  };

  const ticketViews = data?.getTicketViews;

  for (let k = 0; k < ticketViews.length; k++) {
    ticketViewSection.items.push({
      label: ticketViews[k].name,
      type: 'ticket',
      ...ticketViews[k]
    });
  }

  sections.push(ticketViewSection);

  console.log('CSK data getTicketViews ', sections, data.getTicketViews);

  return (
    <div>
      <Sheet open={sheetActive} onClose={toggleSheetActive}>
        {!ticketViewloading && (
          <SelectionSheet
            sections={sections}
            actions={actions}
            meta={{ heading: 'Workspace', selectedTitle: 'Selected items' }}
            data={allFields}
            selectedItems={selectedItems}
            toggleSheetActive={toggleSheetActive}
            updateParent={props.updateParent}
          ></SelectionSheet>
        )}
      </Sheet>
      <Button
        id="createNewWorkspace"
        onClick={toggleSheetActive}
        icon={<SVGIcon name="SettingsDark" />}
      >
        Customize
      </Button>
    </div>
  );
}

function WorspaceContainer(props) {
  const { item } = props;
  const context = useContext(TicketContext);
  const options = { pageSize: 10, page: 1 };
  const [data, setData] = useState([]);
  const [columnGroup, setColumnGroup] = useState([
    { Header: 'Name', columns: [] }
  ]);
  const [skipPageReset, setSkipPageReset] = React.useState(false);
  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);

  const columnGroupData = React.useMemo(
    () => [
      {
        Header: 'Name',
        columns: [
          {
            Header: 'Ticket ID',
            accessor: 'ticketId',
            type: 'Priority',
            className: 'sticky',
            disableResizing: true,
            minWidth: 180
          },
          {
            Header: 'Subject',
            accessor: 'subject',
            type: 'HTML',
            className: 'sticky',
            disableResizing: true,
            actions: {
              onClick: context.openTicket
            }
          },
          {
            Header: 'Requester',
            accessor: 'requester',
            type: 'Text',
            className: 'sticky',
            disableResizing: true
          },
          {
            Header: 'Priority',
            accessor: 'priority',
            type: 'Text',
            className: 'sticky',
            disableResizing: false
          },
          {
            Header: 'Resolution Timer',
            accessor: 'resolutiontimer',
            type: 'Timer',
            className: 'sticky',
            disableResizing: false
          },
          {
            Header: 'Status',
            accessor: 'status',
            type: 'Status',
            disableResizing: false
          },
          {
            Header: 'Assignee',
            accessor: 'assignee',
            type: 'Text',
            disableResizing: false
          },
          {
            Header: 'Client',
            accessor: 'client',
            subAccessor: 'name',
            type: 'Text',
            disableResizing: false
          },
          {
            Header: 'Tasks',
            accessor: 'tasks',
            type: 'Step',
            disableResizing: false
          }
        ]
      }
    ],
    []
  );

  const {
    loading: ticketListLoading,
    error: ticketListError,
    data: ticketList
  } = useQuery(GET_TICKET_LIST, {
    variables: { listInfo: options, isMSPProduct },
    onCompleted: (data) => {
      setColumnGroup(columnGroupData);
      setData(data?.getTicketList?.tickets);
    }
  });

  console.log('CSK ticketList ', ticketList, item);

  return (
    <StyledCard className="fx col">
      <h2 className="Polaris-Heading p16">{item.label}</h2>
      {ticketListLoading ? (
        <TableLoading rows={4}></TableLoading>
      ) : (
        <TicketTable
          context={context}
          columns={columnGroup}
          data={data}
          setData={setData}
          Pagination={false}
        ></TicketTable>
      )}
    </StyledCard>
  );
}

function Workspace(props) {
  const appContext = useContext(AppContext);
  const currentUser = appContext?.user || {};
  const { history, match } = props;

  const {
    loading: customLoading,
    error: customError,
    data: personalization
  } = useQuery(GET_PERSONALIZATION_BY_NAME, {
    client: AccountClient,
    variables: {
      userId: currentUser.userId,
      category: 'Workspace',
      name: match.params.pagename
    }
  });

  const [savePersonalization] = useMutation(SAVE_PERSONALIZATION, {
    client: AccountClient,
    onCompleted({ savePersonalization }) {
      if (savePersonalization) {
        toast('success', 'Time trigger created successfully');
      }
    }
  });

  // useEffect(() => {
  //   if (data?.getTicketViews)
  //   {
  //     const ticketViewSection = {
  //       name: 'TicketView',
  //       header: 'Ticket views',
  //       items: []
  //     }
  //     const ticketViews = data?.getTicketViews

  //     for (let k = 0; k < ticketViews.length; k++) {
  //       console.log("CSK ticketViews ", ticketViews, ticketViews[k], ticketViews[k].name);
  //       ticketViewSection.items.push({ label: ticketViews[k].name, name: ticketViews[k].name, id: ticketViews[k].id});
  //     }
  //     sections.push(ticketViewSection);

  //   }
  // }, [data]);

  const context = useContext(TicketContext);
  const updateParent = useCallback((selectedColumns) => {
    const personalization = {
      user: currentUser,
      category: 'Workspace',
      name: 'workspace',
      value: JSON.stringify(selectedColumns)
    };
    console.log('CSK personalisation', personalization);
    // savePersonalization({
    //   variables: personalization,
    //   input: personalization
    // });
  }, []);

  // console.log("CSK ticketViews ", props.ticketViews, match.params.pagename, personalization?.getPersonalizationByCategoryAndName)

  if (customLoading) return <div>Loading</div>;
  const workspace = JSON.parse(
    personalization?.getPersonalizationByCategoryAndName.value
  );

  return (
    <div className="p16">
      {workspace.length == 0 && (
        <div className="fx col actr fh">
          <Heading>Organize your work smartly with workspace</Heading>
          <WorkspaceSheet updateParent={updateParent}></WorkspaceSheet>
        </div>
      )}
      {workspace.map((item) => {
        return <WorspaceContainer item={item}></WorspaceContainer>;
      })}
    </div>
  );
}

export default withRouter(Workspace);
